/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const ArrowPathIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path fillRule="evenodd" d="M3.065 9.606a9.25 9.25 0 0 1 15.477-4.147l1.473 1.473V4.356a1 1 0 1 1 2 0v4.992a1 1 0 0 1-1 1h-4.992a1 1 0 0 1 0-2h2.58l-1.476-1.475a7.25 7.25 0 0 0-12.13 3.251 1 1 0 0 1-1.932-.518m17.162 3.563a1 1 0 0 1 .707 1.225 9.25 9.25 0 0 1-15.477 4.147l-1.473-1.474v2.577a1 1 0 1 1-2 0v-4.992a1 1 0 0 1 1-1h4.993a1 1 0 1 1 0 2h-2.58l1.475 1.476a7.25 7.25 0 0 0 12.13-3.251 1 1 0 0 1 1.225-.708" clipRule="evenodd" /></svg>;
};
export default ArrowPathIcon;